export default "__VITE_ASSET__b8c5e257__"